import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'cv-alert',
  standalone: true,
  imports: [],
  template: `
    <div class="alert">
      <ng-content></ng-content>
    </div>
  `,
  styleUrl: './alert.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AlertComponent {}
